module.exports = __webpack_public_path__ + "static/media/view quiz.8a5a561a.svg";